module.exports = __webpack_public_path__ + "img/how-to-combine-linear-modules-of-different-lengths.6a68a622.png";